import { render, staticRenderFns } from "./questionbank.vue?vue&type=template&id=97c8ad32&scoped=true"
import script from "./questionbank.vue?vue&type=script&lang=js"
export * from "./questionbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c8ad32",
  null
  
)

export default component.exports